import { Badge } from 'avo-ui'
import { Link } from 'react-router-dom'
import { formatDateMoment, setCurrency, setNumberWithPoint } from 'utils/utils'
import icImageDefault from 'assets/images/ic-image-x.svg'

export const TABLE_GIFT = {
    name: 'Gift',
    column: [
        {
            name: 'Gift',
            key: 'gift',
            render: ({ item }) => (
                <Link
                    to={`/product/gift-list/update-gift?giftId=${item?.id}`}
                    className={'flex flex-row gap-3 items-center'}
                >
                    <img className={'w-7 h-7'} src={item?.image_url || icImageDefault} alt={item?.name} />
                    <div className={'capitalize font-medium text-blue-90 hover:font-bold hover:underline'}>
                        {item?.name}
                    </div>
                </Link>
            ),
        },
        {
            name: 'SKU',
            key: 'sku',
            className: 'max-w-[300px] break-words',
        },
        {
            name: 'Price',
            key: 'price',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Stock',
            key: 'stock_quantity',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Last Modified',
            key: 'updated_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'created_at',
    order_type: 'desc',
}

export const SORT_GIFT = [
    {
        label: 'Sort By Name Desc',
        key: 'name-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Name Asc',
        key: 'name-asc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Stock Desc',
        key: 'stock-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Stock Asc',
        key: 'stock-asc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-product',
    },
]

export const FILTER_GIFT = [
    {
        title: 'status',
        key: 'status',
        list: [
            {
                name: 'publish',
                value: 'publish',
            },
            {
                name: 'draft',
                value: 'draft',
            },
        ],
    },
]
